export default "__VITE_ASSET__f884d1c1__"